/**
 * Splits the given array into smaller arrays of the specified size
 * Cant use lodash-chunk because cant install lodash in Alloy
 * @param array
 * @param size
 */
export function chunk(array: unknown[], size: number): unknown[][] {
  const result = [];

  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }

  return result;
}
